jQuery(document).ready(function($) {
    var triggers = $('.js-ai-warningHTML');

    $(triggers).on("click", function(){
        var triggerEl 		= this;
        var resortID  		= $(triggerEl).attr("data-resort-id");
        var aiType	  		= $(triggerEl).attr("data-ai-type");
        var redirectURL 	= $(triggerEl).attr("data-url");
        var messageHTML		= $('#js-ai-fees-message').html();
        var feedMessage	 	= '';
        var badgeURL		= '';
        var badgeAlt		= '';

        if(aiType === 'M'){
        	feedMessage = 'This is a Mandatory All-Inclusive resort, which means that you must participate in all-inclusive and are required to pay the associated fees. You’ll pay a base price today and additional fees will be due directly to the resort at or before check-in. The additional fees are detailed lower on this resort’s page as well as during the booking process. Would you like to continue your booking?';
        	badgeURL 	= '//d25ckoihpsjafc.cloudfront.net/rci-afvc/img/allInclusiveTags/all_inclusive_m.png';
        	badgeAlt	= 'Mandatory All-Inclusive Resort';
        }

        messageHTML = messageHTML.replace("MSGDESC", feedMessage);		// Replace message
        messageHTML = messageHTML.replace("MSGREDIR", redirectURL);		// Replace link to booking step 1
 		messageHTML = messageHTML.replace("RESORTID", resortID);		// Replace resort ID in GA code
 		messageHTML = messageHTML.replace('src=""', 'src="' + badgeURL + '"');		// AI Badge URL
        messageHTML = messageHTML.replace("BADGEALT", badgeAlt);		// AI Badge Alt 

        launchInfoDialog(messageHTML);
        return false;
    });
});